import React, { Fragment, useEffect, useState, useRef } from 'react';
import ServiceCenter from '../../models/ServiceCenter';
import Multiselect from 'multiselect-react-dropdown';
import { getApi } from '../../api/endpoints';

const FormPartial = (props) => {
  const { serviceCenter, setServiceCenter } = props;
  let serviceCenterObj = new ServiceCenter(serviceCenter);
  const multiselectOperationalPincodeRef = useRef();
  const multiselectCirclesRef = useRef();
  const multiselectClustersRef = useRef();
  const multiselectAddressPincodeRef = useRef();
  const [selectedDays, setSelectedDays] = useState(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']);
  const [warehousesApi] = getApi('warehouses');
  const [warehouses, setWarehouses] = useState([]);
  const [branchesApi] = getApi('branches');
  const [branches, setBranches] = useState([]);
  const [pincodesApi] = getApi('pincodes');
  const [associatedPincodes, setAssociatedPincodes] = useState([]);
  const [complaintCategoriesApi] = getApi('categories');
  const [complaintCategories, setComplaintCategories] = useState([]);
  const [pincodes, setPincodes] = useState([]);
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const [fetchPincodeDetailsApi] = getApi('showPincode');
  const [clusters, setClusters] = useState([]);
  const [clustersApi] = getApi('clusters');
  const [statesApi] = getApi('states');
  const [states, setStates] = useState([]);

  useEffect(() => {
    fetchWarehouses();
    fetchCircles();
    fetchCategories();
    fetchApiData(statesApi, "states", { fields: 'options' }, setStates);
  }, [])

  const fetchApiData = async (api, key, params = {}, setFunction) => {
    try {
      const response = await api(params).unwrap();
      setFunction(response.data[key]);
    } catch (error) {
      // toast.error("Something Went Wrong !");
    }
  }

  const fetchWarehouses = async () => {
    try {
      const response = await warehousesApi({ fields: 'options' }).unwrap();
      setWarehouses(response.data.cs_ware_houses);
    } catch (error) {
    }
  }

  const fetchCircles = async () => {
    try {
      const response = await branchesApi({ fields: 'options' }).unwrap();
      setBranches(response.data.branches);
    } catch (error) {
    }
  }

  const fetchClusters = async (params) => {
    try {
      const response = await clustersApi({ filters: { branch_ids: [params] }, fields: 'options' }).unwrap();
      setClusters(response.data.clusters);
    } catch (error) {
    }
  }

  const fetchCategories = async () => {
    try {
      const response = await complaintCategoriesApi({ fields: 'options', filters: { type: 'parent' } }).unwrap();
      setComplaintCategories(response.data.categories);
    } catch (error) {
    }
  }

  const fetchPincodeDetails = async (id) => {
    try{
      const response = await fetchPincodeDetailsApi({id : id}).unwrap();
      serviceCenterObj.city = response.data.pincode.city;
      serviceCenterObj.state = response.data.pincode.state.name;
      serviceCenterObj.state_id = states.filter(state => state.id === response.data.pincode.state.id);
      setServiceCenter(serviceCenterObj.toStateJson());
    } catch (error) {
    }
  }

  const fetchAssociatedPincodes = async (params) => {
    try {
      const response = await pincodesApi(params).unwrap();
      setAssociatedPincodes(response.data.pincodes);
    } catch (error) {
    }
  }

  function onAssociatedPincodeSearch(value) {
    if (value.search(/^\d{5}$/) !== -1) {
      fetchAssociatedPincodes({ filters: { branch_ids: [serviceCenterObj.branch_id], cluster_ids: serviceCenterObj.cluster_ids }, search: value, fields: 'options' });
    }
  }

  const validateValue = (field) => {
    serviceCenterObj.validate(field);
    if(field === 'latitude'){
      serviceCenterObj.validate('longitude');
    }
    if(field === 'longitude'){
      serviceCenterObj.validate('latitude');
    }
  }

  const changeValue = (field, value) => {
    serviceCenterObj[field] = value;
    validateValue(field);
    props.setServiceCenter(serviceCenterObj.toStateJson());
  }

  const onSelectCircle = (selectedList, selectedItem) => {
    multiselectCirclesRef.current.onCloseOptionList();
    serviceCenterObj.branch_id = selectedItem.id;
    serviceCenterObj.cluster_ids = [];
    serviceCenterObj.pincode = "";
    validateValue('branch_id');
    setServiceCenter(serviceCenterObj.toStateJson());
    fetchClusters(selectedItem.id);
    resetClusterValues();
    resetPincodeValues();
    setPincodes([]);
    multiselectAddressPincodeRef.current.resetSelectedValues();
  }

  const onRemoveCircle = (selectedList, removedItem) => {
    multiselectCirclesRef.current.onFocus();
    serviceCenterObj.branch_id = "";
    validateValue('branch_id');
    setServiceCenter(serviceCenterObj.toStateJson());
    resetPincodeValues();
    resetClusterValues();
  }

  const onSelectCluster = (selectedList, selectedItem) => {
    serviceCenterObj.cluster_ids.push(selectedItem.id);
    validateValue('cluster_ids');
    resetPincodeValues();
    setServiceCenter(serviceCenterObj.toStateJson());
  }

  const onRemoveCluster = (selectedList, removedItem) => {
    serviceCenterObj.cluster_ids = serviceCenterObj['cluster_ids'].filter((item) => item !== removedItem.id);
    validateValue('cluster_ids');
    setServiceCenter(serviceCenterObj.toStateJson());
    resetPincodeValues();
  }

  const resetClusterValues = () => {
    serviceCenterObj.cluster_ids = [];
    setClusters([]);
    setServiceCenter(serviceCenterObj.toStateJson());
    multiselectClustersRef.current.resetSelectedValues();
  }

  const resetPincodeValues = () => {
    serviceCenterObj.pincodes = [];
    setAssociatedPincodes([]);
    setServiceCenter(serviceCenterObj.toStateJson());
    multiselectOperationalPincodeRef.current.resetSelectedValues();
  }

  const onSelectOperationalPincodes = (selectedList, selectedItem) => {
    serviceCenterObj.pincodes.push(selectedItem.id);
    validateValue('pincodes');
    setServiceCenter(serviceCenterObj.toStateJson());
  }

  const onRemoveOperationalPincodes = (selectedList, removedItem) => {
    serviceCenterObj.pincodes = serviceCenterObj['pincodes'].filter((item) => item !== removedItem.id);
    validateValue('pincodes');
    setServiceCenter(serviceCenterObj.toStateJson());
  }

  const onSelectCategories = (selectedList, selectedItem) => {
    serviceCenterObj.category_ids.push(selectedItem.id);
    validateValue('category_ids');
    setServiceCenter(serviceCenterObj.toStateJson());
  }

  const onRemoveCategories = (selectedList, removedItem) => {
    serviceCenterObj.category_ids = serviceCenterObj.category_ids.filter((item) => item !== removedItem.id);
    validateValue('category_ids');
    setServiceCenter(serviceCenterObj.toStateJson());
  }

  const onSelectPincode = (selectedList, selectedItem) => {
    serviceCenterObj.pincode = selectedItem.id;
    validateValue('pincode');
    fetchPincodeDetails(selectedItem.id);
    setServiceCenter(serviceCenterObj.toStateJson());
  }

  const onRemovePincode = (selectedList, removedItem) => {
    serviceCenterObj.pincode = "";
    validateValue('pincode');
    serviceCenterObj.city = "";
    serviceCenterObj.state = "";
    setServiceCenter(serviceCenterObj.toStateJson());
  }

  const handleDayChange = (day) => {
    const updated = toggleElement(selectedDays, day);
    setSelectedDays(updated);
    serviceCenterObj.days = updated.toString();
    validateValue('days');
    setServiceCenter(new ServiceCenter(serviceCenterObj));
  }

  function toggleElement(array, element) {
    if (array.includes(element)) {
      return array.filter(el => el !== element)
    } else {
      return [...array, element]
    }
  }

  const searchPincodes = async (params) => {
    try {
      const response = await pincodesApi(params).unwrap();
      setPincodes(response.data.pincodes);
    } catch (error) {
    }
  }

  function onPincodeSearch(value) {
    if (value.search(/^\d{5}$/) !== -1 || value.search(/^\d{6}$/) !== -1) {
      searchPincodes({ filters: { branch_ids: [serviceCenterObj.branch_id] }, search: value, fields: 'options' });
    }
  }

  return <Fragment>
    <div className="mb-0 col-md-6">
      <label htmlFor="service_center_type" className="form-label mb-0">Service Center Type</label>
      <select
        id="service_center_type"
        onChange={(e) => changeValue('service_center_type', e.target.value)}
        className="form-control form-control-sm font-size-11"
        value={serviceCenterObj.service_center_type}
      >
        <option disabled value="">Choose Service Center type</option>
        <option value="dsc">DSC</option>
        <option value="sf">SF</option>
      </select>
      <div id="service_center_type_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.service_center_type}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="sloc" className="form-label mb-0">SLOC</label>
      <input
        id="sloc"
        value={serviceCenterObj.sloc}
        onChange={(e) => changeValue('sloc', e.target.value)}
        type="text"
        className="form-control form-control-sm font-size-11"
        placeholder='Enter Service Location'
        aria-describedby='sloc_help'
      />
      <div id="sloc_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.sloc}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="name" className="form-label mb-0">Name</label>
      <input
        id="name"
        value={serviceCenterObj.name}
        onChange={(e) => changeValue('name', e.target.value)}
        type="text"
        className="form-control form-control-sm font-size-11"
        placeholder='Enter Service Center Name'
        aria-describedby='name_help'
      />
      <div id="name_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.name}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="tally_account_id" className="form-label mb-0">SAP Code</label>
      <input
        id="tally_account_id"
        value={serviceCenterObj.tally_account_id}
        onChange={(e) => changeValue('tally_account_id', e.target.value)}
        type="text"
        className="form-control form-control-sm font-size-11"
        placeholder='Enter SAP Code'
      />
      <div id="tally_account_id_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.tally_account_id}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="cs_ware_house_id" className="form-label mb-0">Warehouse</label>
      <select
        id="cs_ware_house_id"
        onChange={(e) => changeValue('cs_ware_house_id', e.target.value)}
        className="form-control form-control-sm font-size-11"
        value={serviceCenterObj.cs_ware_house_id}
      >
        <option disabled value="">Select Warehouse</option>
        {warehouses.map((warehouse) => (
          <option key={warehouse.id} value={warehouse.id}>
            {warehouse.name}
          </option>
        ))}
      </select>
      <div id="cs_ware_house_id_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.cs_ware_house_id}
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="profiles" className="form-label mb-1">Is Rental Services Available</label>
      <div className="form-check mt-2">
        <input
          id="rental_services_available"
          className="form-check-input"
          type="checkbox"
          onChange={(e) => {
            serviceCenterObj.rental_services_available = e.target.checked;
            setServiceCenter(new ServiceCenter(serviceCenterObj));
          }}
          value='rental_services_available'
          checked={serviceCenterObj.rental_services_available}
        />
        <label className="form-check-label" htmlFor="rental_services_available">
          {serviceCenterObj.rental_services_available ? 'Yes' : 'No'}
        </label>
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="category_ids" className="form-label mb-0">Select Complaint Categories</label>
      <Multiselect
        id='category_ids'
        options={complaintCategories}
        avoidHighlightFirstOption={true}
        onSelect={(selectedList, selectedItem) => onSelectCategories(selectedList, selectedItem)}
        onRemove={(selectedList, removedItem) => onRemoveCategories(selectedList, removedItem)}
        displayValue="name"
        placeholder={'Select Categories'}
        showArrow={true}
        customArrow={true}
      />
      <div id="complaint_categories_help" className="form-text text-danger m-0">
        {serviceCenterObj.errors.category_ids}
      </div>
    </div>
    <div className="col-md-12 bg-success-subtle rounded">
      <h5 className='pt-2'>Operational PIN Codes</h5>
    </div>
    <div className="mb-0 col-md-4">
      <label htmlFor="branch_id" className="form-label mb-0">Select Circle</label>
      <Multiselect
        id='branch_id'
        options={branches}
        avoidHighlightFirstOption={true}
        singleSelect={true}
        onSelect={(selectedList, selectedItem) => onSelectCircle(selectedList, selectedItem)}
        onRemove={(selectedList, removedItem) => onRemoveCircle(selectedList, removedItem)}
        placeholder="Select Circle"
        displayValue={'name'}
        showArrow={true}
        customArrow={true}
        ref={multiselectCirclesRef}
      />
      <div id="branch_id_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.branch_id}
      </div>
    </div>
    <div className="mb-2 col-md-4">
      <label htmlFor='cluster_ids' className="form-label mb-0">Select Cluster</label>
      <Multiselect
        id='cluster_ids'
        options={clusters}
        avoidHighlightFirstOption={true}
        onSelect={(selectedList, selectedItem) => onSelectCluster(selectedList, selectedItem)}
        onRemove={(selectedList, removedItem) => onRemoveCluster(selectedList, removedItem)}
        placeholder='Select Cluster'
        displayValue={'name'}
        disable={!serviceCenterObj.branch_id}
        showArrow={true}
        customArrow={true}
        ref={multiselectClustersRef}
      />
    </div>
    <div className="mb-2 col-md-4">
      <label htmlFor='pincodes' className="form-label mb-0"> Select PIN Codes</label>
      <Multiselect
        id='pincodes'
        options={associatedPincodes}
        selectedValues={serviceCenterObj.pincodes}
        avoidHighlightFirstOption={true}
        onSelect={(selectedList, selectedItem) => onSelectOperationalPincodes(selectedList, selectedItem)}
        onRemove={(selectedList, removedItem) => onRemoveOperationalPincodes(selectedList, removedItem)}
        onSearch={onAssociatedPincodeSearch}
        emptyRecordMsg={"Search Correct Pincode"}
        placeholder='Select Pincodes'
        displayValue={'code'}
        disable={serviceCenterObj.branch_id === ""}
        ref={multiselectOperationalPincodeRef}
        showArrow={true}
        customArrow={true}
      />
      <div id="associated_pincodes_help" className="form-text text-danger m-0">
        {serviceCenterObj.errors.pincodes}
      </div>
    </div>

    <div className="col-md-12 bg-success-subtle rounded">
      <h5 className='pt-2'>Address</h5>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="address" className="form-label mb-0">Address</label>
      <textarea
        id="address"
        value={serviceCenterObj.address}
        onChange={(e) => changeValue('address', e.target.value)}
        type="textarea"
        className="form-control form-control-sm font-size-11"
        placeholder='Enter address'
        aria-describedby='address_help'
      />
      <div id="address_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.address}
      </div>
    </div>
    <div className="mb-0 col-md-3">
      <label htmlFor="latitude" className="form-label mb-0">Latitude</label>
      <input
        id="latitude"
        value={serviceCenterObj.latitude}
        onChange={(e) => changeValue('latitude', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-11"
        placeholder='Enter Latitude'
        aria-describedby='latitude_help'
      />
      <div id="latitude_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.latitude}
      </div>
    </div>
    <div className="mb-0 col-md-3">
      <label htmlFor="longitude" className="form-label mb-0">Longitude</label>
      <input
        id="longitude"
        value={serviceCenterObj.longitude}
        onChange={(e) => changeValue('longitude', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-11"
        placeholder='Enter Longitude'
        aria-describedby='longitude_help'
      />
      <div id="longitude_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.longitude}
      </div>
    </div>
    <div className="mb-0 col-md-4">
      <label htmlFor="pincode" className="form-label mb-0">PIN Code</label>
      <Multiselect
        id='pincode'
        options={pincodes}
        avoidHighlightFirstOption={true}
        onSelect={(selectedList, selectedItem) => onSelectPincode(selectedList, selectedItem)}
        onRemove={(selectedList, removedItem) => onRemovePincode(selectedList, removedItem)}
        onSearch={onPincodeSearch}
        emptyRecordMsg={"Enter Correct Pincode to Search"}
        selectionLimit={1}
        placeholder='Search & Select Pincode'
        displayValue={'code'}
        showArrow={true}
        customArrow={true}
        disable={!serviceCenterObj.branch_id}
        ref={multiselectAddressPincodeRef}
      />
      <div id="pincode_help" className="form-text text-danger mb-0 mt-0">
        {serviceCenterObj.errors.pincode}
      </div>
    </div>
    <div className="mb-0 col-md-4">
      <label htmlFor="city" className="form-label mb-0">City</label>
      <input
        id="city"
        value={serviceCenterObj.pincode ? serviceCenterObj.city : ""}
        type="text"
        className="form-control form-control-sm font-size-11"
        placeholder='Select pincode first.'
        disabled
      />
    </div>
    <div className="mb-0 col-md-4">
      <label htmlFor="state" className="form-label mb-0">State</label>
      <input
        id="state"
        value={serviceCenterObj.pincode ? serviceCenterObj.state : ""}
        type="text"
        className="form-control form-control-sm font-size-11"
        placeholder='Select pincode first.'
        disabled
      />
    </div>

    <div className="col-md-12 bg-success-subtle rounded">
      <h5 className='pt-2'>Working hours</h5>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="time" className="form-label mb-2">Working Time</label>
      <div className='d-flex' id='time'>
        <div className="mb-2 col-md-3">
          <input
            id='start_time'
            type="time"
            className="form-control form-control-sm"
            value={serviceCenterObj.start_time}
            onChange={(e) => changeValue('start_time', e.target.value)}
          />
        </div>
        <div className="mb-2 col-md-2 text-center pt-2">
          To
        </div>
        <div className="mb-2 col-md-3">
          <input
            id='end_time'
            type="time"
            className="form-control form-control-sm"
            value={serviceCenterObj.end_time}
            onChange={(e) => changeValue('end_time', e.target.value)}
          />
        </div>
      </div>
      <div className='d-flex'>
        <div id="start_time_help" className="form-text text-danger mt-0 col-md-5">
          {serviceCenterObj.errors.start_time}
        </div>
        <div id="end_time_help" className="form-text text-danger mt-0 col-md-5">
          {serviceCenterObj.errors.end_time}
        </div>
      </div>
    </div>
    <div className="mb-0 col-md-6">
      <label htmlFor="days" className="form-label mb-2">Working Days</label>
      {days.map(day => (
        <section key={day}>
          <input
            id="days"
            type="checkbox"
            onChange={(e) => handleDayChange(day)}
            checked={selectedDays.includes(day)}
            className='mt-1'
          />
          <label className='ms-2'>{day}</label>
        </section>
      ))}
      <div id="days_help" className="form-text text-danger mt-0">
        {serviceCenterObj.errors.days}
      </div>
    </div>
  </Fragment>
}

export default FormPartial;
